module.exports = __webpack_public_path__ + "static/terms_of_service_and_use_of_the_bank_card_of_bank_131_archive-e17adf48034fab32f9fd0ede85960068.pdf";